import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';


export interface SmsCreditParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface SmsCredit { 

    id?:number;
    sMSCreditDate?:any;
    sMSCreditedBy:number;
    sMSCreditsms:number;
   
    branchId: string;
    tenantId: string;  
    
    parameters?: SmsCreditParameter[];
    links?: any;
}


export abstract class SmsCreditData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<SmsCredit[]>;
    abstract create(url: string, data: SmsCredit): Observable<SmsCredit[]>;
    abstract update(url: string, data: SmsCredit): Observable<SmsCredit>;
}
